import BPSubProdSelectedNominal from '@atoms/BPSubProdSelectedNominal';
import navigationConstants from '@navigation/navigationConstants';
import { NavigationProp } from '@react-navigation/native';
import { logRequestBP } from '@screens/GGBillPayments/GGNominals/analyticsNominals';
import React from 'react';
import { TouchableOpacity } from 'react-native';
import styles from './styles';

interface Nominal {
  code: string;
  availability: boolean;
  iconLink?: string;
  name: string;
  nominal: {
    amount: number;
    value: number;
  };
}

interface ProductConfig {
  [key: string]: any; // We can make this more specific based on actual usage
}

interface ProductApiData {
  prefix: string;
  [key: string]: any; // We can make this more specific based on actual usage
}

interface SelectedBPAccount {
  id: string;
  amplitudeAccountName: string;
}

interface InlineFunctionsParams {
  setSelectedNominal: (nominal: Nominal) => void;
  setShowNominalsModal: (show: boolean) => void;
  productId: number;
  navigation: NavigationProp<any>;
  selectedProductItem: string;
  productNominals: Record<string, Nominal[]>;
  selectedNominal: Nominal | null;
  selectedAccountNumber: string;
  selectedBPAccount: SelectedBPAccount;
  productConfig: ProductConfig;
  productApiData: ProductApiData;
  requestBP: (request: any) => void;
  validatedReferralCode: string | null;
  source: string;
  meAmplitudeContext: any[];
  isFavourite: boolean;
}

interface InlineFunctionsReturn {
  btnToShowNominals: () => void;
  onPressSubProdOrNominals: () => void;
  closeModalCallBack: () => void;
  listOfNominalsForSubProducts: ({ item }: { item: Nominal }) => React.ReactElement;
}

export default function setOfInlineFunctions(params: InlineFunctionsParams): InlineFunctionsReturn {
  const {
    setSelectedNominal,
    setShowNominalsModal,
    productId,
    navigation,
    selectedProductItem,
    productNominals,
    selectedNominal,
    selectedAccountNumber,
    selectedBPAccount,
    productConfig,
    productApiData,
    requestBP,
    validatedReferralCode,
    source,
    meAmplitudeContext,
    isFavourite,
  } = params;

  const listOfNominalsForSubProducts = ({ item }: { item: Nominal }) => (
    <TouchableOpacity
      testID="btnForNominals"
      onPress={() => {
        if (item.availability) {
          setSelectedNominal(item);
          setShowNominalsModal(false);
        }
      }}
      style={styles.listStyle}>
      <BPSubProdSelectedNominal selectedNominal={item} />
    </TouchableOpacity>
  );

  const closeModalCallBack = () => setShowNominalsModal(false);

  const btnToShowNominals = () => {
    setShowNominalsModal(true);
  };

  const onPressSubProdOrNominals = () => {
    if (!selectedNominal) return;

    if (productId === 13) {
      // bp request for vouchers
      navigation.navigate(navigationConstants.GG_VOUCHER_DETAILS, {
        selectedVoucher: selectedProductItem,
        voucherImage: productNominals[selectedProductItem][0].iconLink,
        selectedNominal,
        selectedAccountNumber,
        selectedBPAccount,
        productConfig,
        productApiData,
        requestBP,
        selectedProductItem,
      });
    } else {
      // bp request for e-money
      logRequestBP(
        selectedAccountNumber,
        productConfig,
        selectedNominal,
        source,
        null,
        meAmplitudeContext,
        selectedBPAccount.amplitudeAccountName,
        isFavourite,
      );
      const request = {
        accountNumber: selectedAccountNumber,
        employeeAccountNumber: selectedBPAccount.id,
        transCategoryPrefix: productApiData.prefix,
        productCode: selectedNominal.code,
        referralCode: validatedReferralCode,
        zoneId: null,
        month: null,
      };
      requestBP(request);
    }
  };

  return { btnToShowNominals, onPressSubProdOrNominals, closeModalCallBack, listOfNominalsForSubProducts };
}
